module.exports = __webpack_public_path__ + "static/media/Zack Jarman Headshot_1728396662300.9e358b93.png";